import { AuthenticatorService } from './../../Shared/Services/authenticator.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Especialidad } from 'src/app/Shared/Interfaces/especialidad.interface';

@Injectable({
    providedIn: 'root',
})
export class EspecialidadesService {
    private base_url: string = environment.baseUrl;

    constructor(private http: HttpClient, private auth: AuthenticatorService) {}

    obtenerEspecialidad(idEspecialidad): Observable<Especialidad> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades/${idEspecialidad}`;
        return this.http.get<Especialidad>(url_api, { headers });
    }

    obtenerTodasEspecialidades(): Observable<Especialidad[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades`;

        return this.http.get<Especialidad[]>(url_api, { headers });
    }

    obtenerEspecialidadesPorCarreraReticula(
        carrera: number,
        reticula: number
    ): Observable<Especialidad[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades-activas/${carrera}/${reticula}`;

        return this.http.get<Especialidad[]>(url_api, { headers });
    }

    obtenerTodasEspecialidadesPorCarreraReticula(
        carrera: number,
        reticula: number
    ): Observable<Especialidad[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades/${carrera}/${reticula}`;

        return this.http.get<Especialidad[]>(url_api, { headers });
    }

    guardarEspecialidad(especialidad: Especialidad): Observable<any> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades`;
        return this.http.post(url_api, especialidad, { headers });
    }

    editarEspecialidad(especialidad: Especialidad): Observable<any>{
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades-edit`;
        return this.http.put(url_api, especialidad, { headers });
    }

    UpdateEspecialidad(
        especialidad: Especialidad,
    ): Observable<Especialidad> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades/${especialidad.especialidad}`;
        return this.http.patch<Especialidad>(url_api, especialidad, {headers});
    }

    obtenerMaxEspecialidad(): Observable<Especialidad>{
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades/maxespecialidad`;
        return this.http.get<any>(url_api, {headers});
    }

    CreateEspecialidad(
        especialidad: Especialidad
    ): Observable<Especialidad> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/especialidades`;
        return this.http.post<Especialidad>(url_api, especialidad, {headers});
    }
}
